module.exports = __webpack_public_path__ + "img/message_thankyou.a4fa7482.svg";